{
    "locale": "zh-tw",
    "title": "GDS-15老年憂鬱症量表",
    "description": "憂鬱是全球的疾病負擔之一，與社區老人的生活品質有著密切的關連，目前台灣老人情緒篩檢量表以台灣老人憂鬱情緒量表(TGDS)及老人憂鬱量表(GDS-15)為主，篩檢對象為65歲以上之民眾，篩檢題目共計15題。",
    "pages": [
      {
        "name": "page1",
        "elements": [
          {
            "type": "panel",
            "name": "panel1",
            "title": "基本資料",
            "elements": [
              {
                "type": "text",
                "name": "name",
                "title": "姓名",
                "isRequired": true,
                "autocomplete": "name"
              },
              {
                "type": "text",
                "name": "identityNumber",
                "title": "身分證字號"
              },
              {
                "type": "text",
                "name": "telephone",
                "title": "電話",
                "isRequired": true,
                "inputType": "tel",
                "autocomplete": "tel"
              },
              {
                "type": "text",
                "name": "birthday",
                "title": "生日",
                "isRequired": true,
                "inputType": "date",
                "autocomplete": "bday"
              },
              {
                "type": "radiogroup",
                "name": "sex",
                "title": "性別",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "男"
                  },
                  {
                    "value": 0,
                    "text": "女"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "text",
                "name": "contactName",
                "title": "連絡人"
              },
              {
                "type": "text",
                "name": "contactTelephone",
                "title": "連絡人電話",
                "inputType": "tel"
              },
              {
                "type": "text",
                "name": "relation",
                "title": {
                  "zh-tw": "關係"
                }
              },
              {
                "type": "radiogroup",
                "name": "marriageStatus",
                "title": "婚姻狀況",
                "choices": [
                  {
                    "value": 1,
                    "text": "已婚"
                  },
                  {
                    "value": 2,
                    "text": "喪偶"
                  },
                  {
                    "value": 3,
                    "text": "離婚"
                  }
                ],
                "showOtherItem": true,
                "otherText": "其他（請說明）"
              },
              {
                "type": "text",
                "name": "livingAddress",
                "title": "居住地址",
                "isRequired": true,
                "autocomplete": "street-address"
              },
              {
                "type": "radiogroup",
                "name": "livingStatus",
                "title": "居住狀況",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "與配偶同住"
                  },
                  {
                    "value": 2,
                    "text": "與家人同住（如子女、孫子女）"
                  },
                  {
                    "value": 3,
                    "text": "獨居"
                  },
                  {
                    "value": 4,
                    "text": "安養機構"
                  }
                ],
                "showOtherItem": true,
                "otherText": "其他（請說明）"
              },
              {
                "type": "checkbox",
                "name": "bodyStatus",
                "title": "身體狀況",
                "choices": [
                  {
                    "value": 1,
                    "text": "糖尿病"
                  },
                  {
                    "value": 2,
                    "text": "高血壓"
                  },
                  {
                    "value": 3,
                    "text": "心臟病"
                  },
                  {
                    "value": 4,
                    "text": "腎臟病"
                  },
                  {
                    "value": 5,
                    "text": "癌症"
                  }
                ],
                "showOtherItem": true,
                "otherText": "其他（請說明）"
              },
              {
                "type": "comment",
                "name": "otherInfo",
                "title": "其他補充資訊"
              },
              {
                "type": "text",
                "name": "testLocation",
                "title": "篩檢地點"
              },
              {
                "type": "text",
                "name": "fillFormDate",
                "title": "填表日期",
                "defaultValueExpression": "today()",
                "inputType": "date"
              }
            ]
          }
        ]
      },
      {
        "name": "page2",
        "elements": [
          {
            "type": "panel",
            "name": "panel2",
            "title": "請根據您最近一周內的感受，回答下列問題",
            "elements": [
              {
                "type": "radiogroup",
                "name": "satisfactionLevel",
                "title": "基本上，您對您的生活滿意嗎？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "activityInterestReduction",
                "title": "您是否減少很多的活動和興趣的事？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "emptinessFeeling",
                "title": "您是否覺得您的生活很空虛？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "boredomFeeling",
                "title": "您是否常常感到厭煩？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "mentalWellbeing",
                "title": "您是否大部份時間精神都很好？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "fearOfUnfortunateEvents",
                "title": "您是否會常常害怕將有不幸的事情發生在您身上嗎？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "happinessFeeling",
                "title": "您是否大部份的時間都感到快樂？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "helplessFeeling",
                "title": "您是否常常感到無論做什麼事，都沒有用？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "homebodyTendency",
                "title": "您是否比較喜歡待在家裡而較不喜歡外出及不喜歡做新的事？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "memoryDifficulty",
                "title": "您是否覺得現在有記憶力不好的困擾？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "lifeAppreciation",
                "title": "您是否覺得「現在還能活著」是很好的事？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "worthlessnessFeeling",
                "title": "您是否覺得您現在活得很沒有價值？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "vitalityFeeling",
                "title": "您是否覺得精力很充沛？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "hopelessFeeling",
                "title": "您是否感覺您現在的情況是沒有希望的？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              },
              {
                "type": "radiogroup",
                "name": "happinessComparison",
                "title": "您是否覺得大部份的人都比您更幸福？",
                "isRequired": true,
                "choices": [
                  {
                    "value": 1,
                    "text": "是"
                  },
                  {
                    "value": 0,
                    "text": "否"
                  }
                ],
                "colCount": 2
              }
            ]
          }
        ]
      },
      {
        "name": "page4",
        "elements": [
          {
            "type": "panel",
            "name": "panel3",
            "elements": [
              {
                "type": "panel",
                "name": "panel3-1",
                "readOnly": true,
                "title": "填答結果",
                "elements": [
                  {
                    "type": "text",
                    "name": "totalCounts",
                    "title": "總分",
                    "defaultValueExpression": "{satisfactionLevel} + {activityInterestReduction} + {emptinessFeeling} + {boredomFeeling} + (1 - {mentalWellbeing}) + {fearOfUnfortunateEvents} + (1 - {happinessFeeling}) + {helplessFeeling} + {homebodyTendency} + {memoryDifficulty} + (1 - {lifeAppreciation}) + {worthlessnessFeeling} + (1 - {vitalityFeeling}) + {hopelessFeeling} + {happinessComparison}",
                    "readOnly": true
                  },
                  {
                    "type": "text",
                    "name": "Description1",
                    "visibleIf": "{totalCounts} < 7",
                    "title": "篩檢結果",
                    "defaultValueExpression": "\"保持良好心理健康，避免憂鬱情緒\"",
                    "readOnly": true
                  },
                  {
                    "type": "text",
                    "name": "Description2",
                    "visibleIf": "{totalCounts} >= 7 and {totalCounts} <= 10",
                    "title": "篩檢結果",
                    "defaultValueExpression": "\"進行需求評估，心理輔導與諮商，轉介資源\"",
                    "readOnly": true
                  },
                  {
                    "type": "text",
                    "name": "Description3",
                    "visibleIf": "{totalCounts} >= 11",
                    "title": "篩檢結果",
                    "defaultValueExpression": "\"進行需求評估，轉介醫療系統與相關資源\"",
                    "readOnly": true
                  }
                ]
              },
              {
                "type": "radiogroup",
                "name": "dataSource",
                "title": "資料來源",
                "isRequired": true,
                "choices": [
                  {
                    "value": "self",
                    "text": "本人"
                  }
                ],
                "showOtherItem": true,
                "otherText": "其他（請說明）"
              },
              {
                "type": "radiogroup",
                "name": "canReferral",
                "title": "轉介意願",
                "isRequired": true,
                "choices": [
                  {
                    "value": true,
                    "text": "同意轉介"
                  },
                  {
                    "value": false,
                    "text": "不同意轉介"
                  }
                ],
                "colCount": 2
              }
            ]
          },
          {
            "type": "panel",
            "name": "panel4",
            "elements": [
              {
                "type": "text",
                "name": "fillFormName",
                "title": "填表單位名稱",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "referralsUser",
                "title": "轉介人員",
                "isRequired": true
              },
              {
                "type": "text",
                "name": "fillFormUnitTelephone",
                "title": "填表單位電話",
                "isRequired": true
              }
            ]
          }
        ]
      }
    ],
    "questionErrorLocation": "bottom",
    "widthMode": "static",
    "width": "48rem"
}
